// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./authConfig";
import { AuthProvider } from "./context/AuthContext";
import { ThemeContextProvider } from "./context/ThemeContext";
import { BreadcrumbProvider } from "./context/BreadcrumbContext";
import { loginRequest, b2cPolicies } from "./authConfig";
import { SYSTEM_NAME } from "./config";
import ErrorBoundary from "./components/ErrorBoundary";
import { initializeAppInsights } from "./telemetry/appInsights";
import "./styles/global.css";


async function bootstrap() {
  // Update document title based on environment
  document.title = SYSTEM_NAME;
  initializeAppInsights();

  window.__msal = msalInstance;
  await msalInstance.initialize();

  try {
    const response = await msalInstance.handleRedirectPromise();

    if (response?.error?.message?.includes("AADB2C90118")) {
      await msalInstance.loginRedirect({
        ...loginRequest,
        authority: b2cPolicies.authorities.resetPassword.authority,
      });
      return;
    }
  } catch (e) {
    const msg = e?.message || e?.errorMessage || "";
    if (msg.includes("AADB2C90118")) {
      await msalInstance.loginRedirect({
        ...loginRequest,
        authority: b2cPolicies.authorities.resetPassword.authority,
      });
      return;
    }
    console.error("handleRedirectPromise error:", e);
  }

  const container = document.getElementById("root");
  const root = ReactDOM.createRoot(container);

  root.render(
    <ErrorBoundary>
      <MsalProvider instance={msalInstance}>
        <AuthProvider>
          <ThemeContextProvider>
            <BreadcrumbProvider>
              <App />
            </BreadcrumbProvider>
          </ThemeContextProvider>
        </AuthProvider>
      </MsalProvider>
    </ErrorBoundary>
  );
}

bootstrap();
